import { Hito } from '../../../../models/hito';
import { HitoService } from '../../../../services/hito.service';
import { IpPublicService } from '../../../../../../services/ip-public.service';
import { Component, OnDestroy, OnInit, ViewChild, Input, ElementRef,} from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { AlertService } from '../../../../../../services/alert.service';
import { ModalService } from '../../../../../../services/modal.service';
import { DataTableDirective } from 'angular-datatables';
import { EtapaService } from '../../../../services/etapa.service';
import { ComunService } from 'src/app/modulos/catalogos-proces/services/comun.service';
import { Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { validadorFechaIntervalo } from 'src/app/helpers/validator-form';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { UsuarioRedux } from 'src/app/models/usuario.model';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-hito',
  templateUrl: './hito.component.html',
  styleUrls: ['./hito.component.css'],
})
export class HitoComponent implements OnInit, OnDestroy {
  public formHito!: FormGroup;
  public currentUserRedux: UsuarioRedux = null;
  public formSubmitted = false;
  public currentAmbiente: any;
  public ipAddress!: string;
  public buffer: any;
  public dataHito: any[] = [];
  public dataEtapa!: any;
  private idDeleteRegister: number = 0;
  public selectItems: any[] = [];
  public nameModal: string = 'Cumplimiento de hitos';
  public fechasCumplimientoHitos: string = 'Fechas Cumplimiento de Hitos';
  public nameModal1: string = 'Hitos';
  public maximoHitosEtapa: number;
  public idSprEtapa!: 0;
  public dataCategoriaHitos!: any;
  public desahabilitarForm: boolean = false;
  public pesoMaximo = 0;
  public pesoOcupado = 0;
  public desripcionEtapa!: any;
  public idSprComunCategoriaHitos = ConstantsCatalogosIdService.ID_COMUNES_CATEGORIA_HITO;
  public bitesMaximoPdf = ConstantsCatalogosIdService.BIT_MAXIMO_PDF_CUMPLE_INDICADOR;
  public idRolAnalistaMetodologico = ConstantsCatalogosIdService.ANALISTA_METODOLOGICO;
  public nameModalDetalleHito: string = 'nameModalDetalleHito';
  public archivoCapturado: any[] = [];
  public idSprNivel: number = 0;
  public idSprUsuario!: number;
  public formHitoCumple!: FormGroup;
  public nombre: any;
  public categoriaHito: any;
  public avance: any =0;
  public fechaEstimada: any;
  public fechaComprometida: any;
  public peso: any;
  public cumplidoHito: any;
  public nombreHito = '';
  public estado: any;
  public submitted = false;
  public pesoRestante: number = 0;
  public pesoEdit: any = 0;
  public pesoTotalEditado: any = 0;
  public editPorcentajeTotal: boolean = true;
  public editPorcentaje: boolean = false;
  private idHito: number = 0;
  public proyectoActual: any;
  hoy = new Date();
  pipe = new DatePipe('en-US');
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  public idSprRolPrincipal: number = 0;
  
  @Input() set data(Etapa: any) {
    this.idSprEtapa = Etapa.idSprEtapa;
    this.desripcionEtapa = Etapa.nombre;
    this.maximoHitosEtapa = Etapa.maximoHitos;
    this.pesoMaximo = Etapa.pesoTotal;
    this.initApp();
  }

  @Input() set proyecto(proyectoInput: any) {
    this.proyectoActual = proyectoInput;
  }

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
 
  @ViewChild('myInput')
  myInputVariable: ElementRef;
  isDtInitialized: boolean = false;

  readonly constant = ConstantsCatalogosIdService;

  constructor(
    private fb: FormBuilder,
    private hitoService: HitoService,
    private alertService: AlertService,
    private ip: IpPublicService,
    public modal: ModalService,
    private etapaService: EtapaService,
    private comunService: ComunService,
    private sanitizer: DomSanitizer,
    private store: Store<AppState>
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentAmbiente = JSON.parse(this.buffer);
    this.selectItems = [
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
  }

  get hitoForm() {
    return this.formHito.controls;
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  initApp() {
    this.listDataEtapa();
    this.setDataTable();
    this.setForm();
  }

  ngOnInit(): void {
    this.store.select('globalApp').subscribe((response) => {
      this.idSprNivel = response.ambienteSeleccionado.nivel.idSprNivel;
      this.idSprRolPrincipal = response.rolSeleccionado.idSprRol;
      this.getIpPublic();
      this.initApp();
    });  
    this.store.select('usuarioApp').subscribe((response) => {
      this.currentUserRedux = response.currentUser;
      this.idSprUsuario = response.currentUser.idSprUsuario;
    });
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }
  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  setForm() {
    if (this.maximoHitosEtapa == 1) {
      this.formHito = this.fb.group({
        idSprHito: [],
        idSprEtapa: [this.idSprEtapa],
        idSprCategoriaHito: ['', [Validators.required]],
        nombre: ['', [Validators.required]],        avance: [0],
        peso: [this.pesoMaximo, [Validators.required]],
        fechaComprometida: ['', [Validators.required, validadorFechaIntervalo(this.proyectoActual.fechaInicio,this.proyectoActual.fechaFin),],],
        fechaEstimada: [this.pipe.transform(this.hoy, 'yyyy-MM-dd')],
        fechaReal: [this.pipe.transform(this.hoy, 'yyyy-MM-dd')],
        estado: [1, [Validators.required]],
      });
      this.formHitoCumple = this.fb.group({
        idSprHito: [],
        idSprEtapa: [],
        idSprCategoriaHito: [],
        cumplimiento: [],
        nombre: ['', [Validators.required]],
        avance: [this.avance],
        respaldoPdf: ['', [Validators.required]],
        estado: [1, [Validators.required]],
      });
    } else {
      this.formHito = this.fb.group({
        idSprResumenEjecutivo:[],
        idSprHito: [],
        idSprEtapa: [this.idSprEtapa],
        idSprCategoriaHito: ['', [Validators.required]],
        nombre: ['', [Validators.required]],
        avance: [0],
        peso: ['', [Validators.required]],
        fechaComprometida: ['',[Validators.required,validadorFechaIntervalo(this.proyectoActual?.fechaInicio,this.proyectoActual?.fechaFin),],],
        fechaEstimada: [this.pipe.transform(this.hoy, 'yyyy-MM-dd')],
        fechaReal: [this.pipe.transform(this.hoy, 'yyyy-MM-dd')],
        estado: [1, [Validators.required]],
      });
      this.formHitoCumple = this.fb.group({
        idSprHito: [],
        idSprEtapa: [],
        idSprCategoriaHito: [],
        cumplimiento: [],
        nombre: ['', [Validators.required]],
        avance: [this.avance],
        respaldoPdf: ['', [Validators.required]],
        estado: [1, [Validators.required]],
      });
    }
  }

  verifyCumple() {
    const cumplidoHito = this.formHito.value.cumplidoHito;
    const respaldoPdf = this.formHito.value.respaldoPdf;
    this.formHito.patchValue({
      ...this.formHito.value,
      avance:
        cumplidoHito === 'S' && respaldoPdf !== null
          ? this.formHito.value.peso
          : 0,
    });
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  validacionPeso(peso: any, pesoRestante: any, pesoTotalEdit: any) {
    if (this.formHito.value.idSprHito == null) {
      if (peso > pesoRestante) {
        if (pesoRestante > 0) {
          this.alertService.warning('¡Atención!','Peso seleccionado debe ser menor o igual que: ' + pesoRestante + '%');
        }
        if (pesoRestante <= 0) {
          this.alertService.warning( '¡Atención!', 'El peso de los hitos ya se cumplio.');
        }
      }
    } else {
      if (peso > pesoTotalEdit) {
        this.alertService.warning('¡Atención!','Peso seleccionado debe ser menor o igual que: ' + pesoTotalEdit + '%');
      }
    }
    return;
  }

  onSubmitHito(hitos: any[], validate: boolean) {
    this.hitoService.list(`?idSprEtapa=${this.idSprEtapa}`).subscribe({
      next: (data) => {
        this.formSubmitted = true;
        this.formHito.value.usuario = this.idSprUsuario;
        this.formHito.value.ip = this.ipAddress;
        this.formHito.value.idSprEtapa = this.idSprEtapa;
        let fechaComprometida =  this.formHito.get('fechaComprometida')?.value;
        let FechaCumplimiento = this.formHito.value.fechaEstimada;
        let peso = this.formHito.value.peso;
        let pesoTotalEdit = this.pesoTotalEditado;
        let pesoRestante = this.pesoRestante;
        this.formHito.value.fechaComprometida = fechaComprometida;
        this.validacionPeso(peso, pesoRestante, pesoTotalEdit);
        // Realiza validaciones de peso
        if (!this.formHito.invalid) {      
          if (this.formHito.value.idSprHito == null && peso <= pesoRestante) {         
            this.formHito.value.fechaEstimada = FechaCumplimiento;
            this.formHito.value.cumplidoHito = 'N';
            // Verifica si se ha alcanzado el máximo de hitos
            if (data.length >= this.maximoHitosEtapa) {
              this.alertService.warning('¡Atención!','No se pueden crear más hitos, se ha alcanzado el máximo permitido.' );
              return;
            }
            this.etapaService.list(`${this.idSprEtapa}`).subscribe({
              next: (resp) => {
                const orden = resp.orden;
                if (resp.orden == 1) {
                  if (data.length <= 0) {
                    this.hitoService.create(this.formHito.value).subscribe({
                      next: (resp) => {
                        this.initApp();
                        this.closeModalHito();
                        this.modal.closeId(this.nameModalDetalleHito);
                        this.alertService.createOk();
                        this.editPorcentajeTotal = true;
                        this.editPorcentaje = false;
                      },
                      error: (err) => {
                        this.alertService.warning('¡Atención!','Error al crear los hitos.'); 
                      },
                    });
                  } else {
                    let maxIdSprHito = -1;
                    data.forEach((elemento) => {
                      if (elemento.idSprHito > maxIdSprHito) {
                        maxIdSprHito = elemento.idSprHito;
                      }
                    });
                    this.hitoService.list(`${maxIdSprHito}`).subscribe({
                      next: (resp) => {
                        let fecha = resp.fechaComprometida;  
                        if (this.formHito.value.fechaComprometida > fecha) {
                          this.hitoService.create(this.formHito.value)
                            .subscribe({
                              next: (resp) => {
                                this.initApp();
                                this.closeModalHito();
                                this.modal.closeId(this.nameModalDetalleHito);
                                this.alertService.createOk();
                                this.editPorcentajeTotal = true;
                                this.editPorcentaje = false;
                              },
                              error: (err) => {
                                this.alertService.warning('¡Atención!','Error al crear los hitos.'); 
                              },
                            });
                        } else {
                          this.alertService.warning('¡Atención!: La fecha comprometida  debe ser mayor a la fecha del último hito anterior ', fecha);
                        }
                      },
                      error: (error) => {
                        this.alertService.warning('¡Atención!','Error al consultar los hitos.'); 
                      },
                    });
                  }
                } else {
                  if (data.length <= 0) {
                    //aqui debo preguntar la fecha de la anterior etapa de sus hitos
                    //traer la etapa y la fecha maxima de los hitos de esa etapa
                    this.etapaService.list(`${(resp.idSprEtapa - 1)}`).subscribe({
                        next: (etapas) => {
                          this.hitoService.list('?idSprEtapa=' + etapas.idSprEtapa)
                            .subscribe({
                              next: (hitos) => {
                                let maxIdSprHito = -1;
                                hitos.forEach((elemento) => {
                                  if (elemento.idSprHito > maxIdSprHito) {
                                    maxIdSprHito = elemento.idSprHito;
                                  }
                                });
                                this.hitoService.list(`${maxIdSprHito}`).subscribe({
                                    next: (resp) => {
                                      let fecha = resp.fechaComprometida;
                                      if (this.formHito.value.fechaComprometida > fecha
                                      ) {
                                        this.hitoService.create(this.formHito.value).subscribe({
                                            next: (resp) => {
                                              this.initApp();
                                              this.closeModalHito();
                                              this.modal.closeId(this.nameModalDetalleHito);
                                              this.alertService.createOk();
                                              this.editPorcentajeTotal = true;
                                              this.editPorcentaje = false;
                                            },
                                            error: (err) => {
                                              // Manejar el error si es necesario
                                            },
                                          });
                                      } else {
                                        this.alertService.warning(
                                          '¡Atención!: La fecha comprometida  debe ser mayor a la fecha del último hito anterior ',
                                          fecha
                                        );
                                      }
                                    },
                                    error: (error) => {
                                      this.alertService.warning('¡Atención!','Error al consultar las hitos.'); 
                                    },
                                  });
                              },
                              error: (error) => {
                                this.alertService.warning('¡Atención!','Error al consultar las hitos.'); 
                              },
                            });
                        },
                        error: (error) => {
                          this.alertService.warning('¡Atención!','Error al consultar las etapas.'); 
                        },
                      });
                  } else {
                    let maxIdSprHito = -1;
                    data.forEach((elemento) => {
                      if (elemento.idSprHito > maxIdSprHito) {
                        maxIdSprHito = elemento.idSprHito;
                      }
                    });
                    this.hitoService.list(`${maxIdSprHito}` ).subscribe({
                      next: (resp) => {
                        let fecha = resp.fechaComprometida;
                        if (this.formHito.value.fechaComprometida > fecha) {
                          this.hitoService.create(this.formHito.value)
                            .subscribe({
                              next: (resp) => {
                                this.initApp();
                                this.closeModalHito();
                                this.modal.closeId(this.nameModalDetalleHito);
                                this.alertService.createOk();
                                this.editPorcentajeTotal = true;
                                this.editPorcentaje = false;
                              },
                              error: (err) => {
                                this.alertService.warning('¡Atención!','Error al crear los hitos.'); 
                              },
                            });
                        } else {
                          this.alertService.warning('La fecha comprometida  debe ser mayor a la fecha del último hito anterior ', fecha);
                        }
                      },
                      error: (error) => {
                        this.alertService.warning('¡Atención!','Error al consultar los hitos.'); 
                      },
                    });
                  }
                }
              },
              error: (error) => {
                this.alertService.warning('¡Atención!','Error al consultar las etapas.'); 
              },
            });
           
          } else 
          if (peso <= pesoTotalEdit) {
            this.etapaService.list(`${this.idSprEtapa}` ).subscribe({
              next: (resp) => {
                const orden = resp.orden;
                if (resp.orden == 1) {
                  if (data.length == 1) { 
                   this.hitoService.update(this.formHito.value).subscribe({
                    next: (resp) => {
                      this.initApp();
                      this.closeModalHito();
                      this.modal.closeId(this.nameModalDetalleHito);
                      this.alertService.updateOk();
                      this.desahabilitarForm = false;
                      this.editPorcentajeTotal = true;
                      this.editPorcentaje = false;
                    },
                    error: (err) => {
                      this.alertService.warning('¡Atención!','Error al actualizar los hitos.'); 
                    },
                  });
                   
                  } else {
                    let minIdSprHito = Number.MAX_SAFE_INTEGER;
                    data.forEach((elemento) => {
                      if (elemento.idSprHito < minIdSprHito) {
                        minIdSprHito = elemento.idSprHito;          
                      }
                    });
                    if (minIdSprHito == this.formHito.value.idSprHito) {
                      this.hitoService.update(this.formHito.value).subscribe({
                        next: (resp) => {
                          this.initApp();
                          this.closeModalHito();
                          this.modal.closeId(this.nameModalDetalleHito);
                          this.alertService.updateOk();
                          this.desahabilitarForm = false;
                          this.editPorcentajeTotal = true;
                          this.editPorcentaje = false;
                        },
                        error: (err) => {
                          this.alertService.warning('¡Atención!','Error al actualizar los hitos.'); 
                        },
                      });
                    } else {    
                      //sacar el valor minimo, y si el minimo es igual al hito de ahorita, editar, si no restar menos 1
                      this.hitoService.list(`${(this.formHito.value.idSprHito - 1)}`).subscribe({
                          next: (resp) => {
                            const fecha = resp.fechaComprometida;                       
                            if (this.formHito.value.fechaComprometida > fecha) {
                              this.hitoService.update(this.formHito.value)
                                .subscribe({
                                  next: (resp) => {
                                    this.initApp();
                                    this.closeModalHito();
                                    this.modal.closeId(this.nameModalDetalleHito);
                                    this.alertService.updateOk();
                                    this.desahabilitarForm = false;
                                    this.editPorcentajeTotal = true;
                                    this.editPorcentaje = false;
                                  },
                                  error: (err) => {
                                    this.alertService.warning('¡Atención!','La fecha de inicio debe ser mayor a la fecha del anterior hito.'); 
                                  },
                                });
                            } else {
                              this.alertService.warning('¡Atención!','La fecha de inicio debe ser mayor a la fecha del anterior hito.'); 
                            }
                          },
                          error: (error) => {
                            this.alertService.warning('¡Atención!','Error al consultar los hitos.'); 
                          },
                        });
                    }
                  }
                } else {
                  if (data.length ==1) {
                  this.etapaService.list(`?orden=` + (resp.orden - 1))
                  .subscribe({
                    next: (etapaAnterior) => {             
                      this.hitoService.list(`?idSprEtapa=` + etapaAnterior[0].idSprEtapa).subscribe({
                        next: (hitosEtapaAnterior) => {
                          let maxFecha = ''; 
                          hitosEtapaAnterior.forEach((elemento) => {
                            if (elemento.fechaComprometida > maxFecha) {
                              maxFecha = elemento.fechaComprometida;
                            }
                          });                         
                         if (this.formHito.value.fechaComprometida > maxFecha) {
                            this.hitoService.update(this.formHito.value).subscribe({
                                next: (resp) => {
                                  this.initApp();
                                  this.closeModalHito();
                                  this.modal.closeId(this.nameModalDetalleHito);
                                  this.alertService.updateOk();
                                  this.desahabilitarForm = false;
                                  this.editPorcentajeTotal = true;
                                  this.editPorcentaje = false;
                                },
                                error: (err) => {
                                  this.alertService.warning(
                                    '¡Atención!',
                                    '  Error al actualizar los hitos.'
                                  ); 
                                },
                              });
                          } else {
                            this.alertService.warning(
                              '¡Atención!,  La fecha de inicio debe ser mayor a la fecha del anterior hito.',maxFecha
                            );
                          }
                        },
                        error:(error)=>{
                          this.alertService.warning(
                            '¡Atención!',
                            'Error al consultar los hitos.'
                          ); 
                        }
                      })
                    }
                  })
                } else {
                  let minIdSprHito = Number.MAX_SAFE_INTEGER;
                  data.forEach((elemento) => {
                    if (elemento.idSprHito < minIdSprHito) {
                      minIdSprHito = elemento.idSprHito;
                    }
                  });
                  if (minIdSprHito == this.formHito.value.idSprHito) {
                    this.hitoService.update(this.formHito.value).subscribe({
                      next: (resp) => {
                        this.initApp();
                        this.closeModalHito();
                        this.modal.closeId(this.nameModalDetalleHito);
                        this.alertService.updateOk();
                        this.desahabilitarForm = false;
                        this.editPorcentajeTotal = true;
                        this.editPorcentaje = false;
                      },
                      error: (err) => {
                        this.alertService.warning('¡Atención!','Error al actualizar los hitos.'); 
                      },
                    });
                  } else {
                    this.hitoService.list(`${(this.formHito.value.idSprHito - 1)}`)
                      .subscribe({
                        next: (resp) => {
                          const fecha = resp.fechaComprometida;
                          if (this.formHito.value.fechaComprometida > fecha) {
                            this.hitoService.update(this.formHito.value)
                              .subscribe({
                                next: (resp) => {
                                  this.initApp();
                                  this.closeModalHito();
                                  this.modal.closeId(this.nameModalDetalleHito);
                                  this.alertService.updateOk();
                                  this.desahabilitarForm = false;
                                  this.editPorcentajeTotal = true;
                                  this.editPorcentaje = false;
                                },
                                error: (err) => {
                                  this.alertService.warning('¡Atención!,','Error al actualizar los hitos'); // El formulario es inválido, no hagas nada
                                },
                              });
                          } else {
                            this.alertService.warning('¡Atención!, La fecha de inicio debe ser mayor a la fecha del anterior hito.',fecha); // El formulario es inválido, no hagas nada
                          }
                        },
                        error: (error) => {
                          this.alertService.warning('¡Atención!','Error al consultar los hitos.'); 
                        },
                      });
                  }
                }
                }
              },
              error: (error) => {
                this.alertService.warning('¡Atención!','Error al consultar las etapas.'); 
              },
            });
          }
        } else {
          this.alertService.warning('¡Atención!','No cumple con los campos requeridos.'); 
        }
      },
    });
  }

  update(obj: Hito) {
    this.editPorcentajeTotal = false;
    this.editPorcentaje = true;
    this.modal.open(this.nameModal);
    this.formHito.patchValue({
      idSprHito: obj.idSprHito,
      idSprEtapa: obj.idSprEtapa,
      idSprCategoriaHito: obj.idSprCategoriaHito,
      nombre: obj.nombre,
      cumplidoHito: obj.cumplidoHito,
      avance: obj.avance,
      peso: obj.peso,
      fechaComprometida: obj.fechaComprometida,
      fechaEstimada: obj.fechaEstimada,
      fechaReal: obj.fechaReal,
      respaldoPdf: obj.respaldoPdf,
      estado: obj.estado,
    });
    this.pesoEdit = obj.peso;
    this.pesoTotalEditado = this.pesoRestante + this.pesoEdit;
    if(this.idSprRolPrincipal != this.idRolAnalistaMetodologico){
      this.formHito.get('fechaComprometida')?.disable();
    }   
  }

  evaluacionHitos(obj: Hito) { 
    this.formSubmitted = true;
    let fechaComprometidaVal;
    let fechaActual;
    fechaComprometidaVal = obj.fechaComprometida;
    fechaActual = this.pipe.transform(this.hoy, 'yyyy-MM-dd');
    if (this.pesoRestante <= 0) {
      if (fechaComprometidaVal >= fechaActual) {
        this.openModalHitoCumple();        
      } else {    
        this.alertService.warning('¡Atención!','Fecha comprometida fuera de vigencia.');
      }
      this.formHito.patchValue({
        idSprHito: obj.idSprHito,
        idSprEtapa: obj.idSprEtapa,
        idSprCategoriaHito: obj.idSprCategoriaHito,
        nombre: obj.nombre,
        cumplidoHito: obj.cumplidoHito,
        avance: obj.avance,
        peso: obj.peso,
        fechaComprometida: obj.fechaComprometida,
        fechaEstimada: obj.fechaEstimada,
        fechaReal: obj.fechaReal,
        respaldoPdf: obj.respaldoPdf,
        estado: obj.estado,
      });

      this.pesoEdit = obj.peso;
      this.pesoTotalEditado = this.pesoRestante + this.pesoEdit;
      this.idHito = obj.idSprHito;
      this.nombre = obj.nombre;
      this.fechaEstimada = obj.fechaEstimada;
      this.fechaComprometida = obj.fechaComprometida;
      this.categoriaHito = obj.idSprCategoriaHito;
      this.avance = obj.avance;
      this.peso = obj.peso;
      this.cumplidoHito = obj.cumplidoHito;
      this.estado = obj.estado;
      this.viewCategoriaHito(obj.idSprCategoriaHito)
    } else {
      this.alertService.warning(
        '¡Atención!',
        'La suma de los pesos de los hitos debe ser completada.'
      );
    }
  }
  openHitoFechas(obj: any) {
    this.nombreHito = obj.nombre;
    this.formHito.patchValue({
      idSprHito: obj.idSprHito,
      idSprEtapa: obj.idSprEtapa,
      idSprCategoriaHito: obj.idSprCategoriaHito,
      nombre: obj.nombre,
      cumplidoHito: obj.cumplidoHito,
      avance: obj.avance,
      peso: obj.peso,
      fechaComprometida: obj.fechaComprometida,
      fechaEstimada: obj.fechaEstimada,
      fechaReal: obj.fechaReal,
      respaldoPdf: obj.respaldoPdf,
      estado: obj.estado,
    });
    this.modal.open(this.fechasCumplimientoHitos);
  }
  onSubmitFechas() {
    this.hitoService.update(this.formHito.value).subscribe(
      (resp) => {
        this.initApp();
        this.closeModalHito();
        this.modal.closeId(this.nameModalDetalleHito);
        this.alertService.updateOk();
        this.desahabilitarForm = false;
        this.editPorcentajeTotal = true;
        this.editPorcentaje = false;
      },
      (err) => {
        // Manejar el error si es necesario
      }
    );
  } 

  ///////////////TRAE DATOS DE PROYECTOS/////////////////
  listDataEtapa() {
    this.etapaService.list().subscribe((resp) => {
      this.dataEtapa = resp;
      this.listDataHito();
    });
  }

  ////////////////////TRAE DATOS DE HITOS//////////////
  listDataHito() {
    if (this.idSprEtapa) {
      this.hitoService.list(`?idSprEtapa=${this.idSprEtapa}`)
        .subscribe((resp) => {
          this.dataHito = resp;
          this.reDrawDataTable();
          this.listCategoriaHito();
          this.pesoOcupado = 0;
          this.calculo(this.dataHito, this.pesoRestante); // envia parametros para realizar el cálculo
          resp.forEach((element) => {
            this.pesoOcupado = this.pesoOcupado + element.peso;
          });
        });
    }
  }
  ///////////////TRAE DATOS DEL CATALOGO COMUN CATEGORIA DE HITO//////////////

  listCategoriaHito() {
    this.comunService.list('?spr_idSprComun=' + this.idSprComunCategoriaHitos).subscribe((resp) => {
        this.dataCategoriaHitos = resp;
      });
  }

  viewCategoriaHito(idSprComun: number) {
    this.comunService.list(`${idSprComun}` )
      .subscribe(resp => {
        this.categoriaHito = resp.nombre;
      })
  }

  /* ################################################# */
  /*******función subir archivo *********************/
  /* ################################################# */
  public archivos: any = [];
  public nameFileGuardado: any;
  public previsualizacion: string;

  visualizarPdf(archivo: string) {
    this.hitoService.download(archivo).subscribe({
      next: (data) => {
        const byteCharacters = atob(data.file);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob: Blob = new Blob([byteArray], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL, '_black');
        FileSaver.saveAs(blob, archivo + '.pdf');
      },
      error: () => {},
    });
  }

  extraerBase64 = async ($event) =>
    new Promise((resolve, reject) => {
      try {
        const unsafeIng = window.URL.createObjectURL($event);
        const image = this.sanitizer.bypassSecurityTrustUrl(unsafeIng);
        const reader = new FileReader();
        reader.readAsDataURL($event);
        reader.onload = () => {
          resolve({
            base: reader.result,
          });
        };
        reader.onerror = (error) => {
          resolve({
            base: null,
          });
        };
      } catch (error) {
        return null;
      }
    });

  capturarFile(event): any {
    this.formSubmitted = false;
    const archivoCapturado = event.target.files[0];
    this.extraerBase64(archivoCapturado).then((imagen: any) => {
      this.previsualizacion = imagen.base;
    });
    this.archivos.push(archivoCapturado);
  }

  // Evento presion de botn guardar respaldo pdf
  subirArchivo(): any {
    this.formSubmitted = true;
    if (this.archivos.length != 0) {
      try {
        const formularioDeDatos = new FormData();
        this.archivos.forEach((archivo) => {
          formularioDeDatos.append('file', archivo);
        });
        this.hitoService
          .postArchivo(formularioDeDatos, this.idHito)
          .subscribe((responseNamePdf) => {
            this.nameFileGuardado = responseNamePdf.filename;
            this.cumpleHito();
          });
      } catch (error) {}
    } else {
      this.alertService.warning('¡Atención!', 'No existe documento de soporte');
      return;
    }
  }

  cumpleHito() {
    if (this.formHito.value.idSprHito != null) {
      this.formHito.value.respaldoPdf = this.nameFileGuardado;
      this.formHito.value.cumplidoHito = 'S';
      this.formHito.value.avance = this.peso;

      this.hitoService.update(this.formHito.value).subscribe(
        (resp) => {
          this.initApp();
          this.closeModalCumpleHito();
          this.alertService.updateOk(
            '!Correcto!',
            'Hito cumplido correctamente.'
          );
          this.editPorcentajeTotal = true;
          this.editPorcentaje = false;
        },
        (err) => {
        }
      );
    }
  }

  /**********************FIN DE CARGA DE ARCHIVOS *****************/

  delete(idRegister: number) {
    this.modal.open('delete-hito');
    this.idDeleteRegister = idRegister;
  }
  confirmDelete() {
    if (this.idDeleteRegister > 0) {
      this.hitoService
        .delete({
          idSprHito: this.idDeleteRegister,
          usuario: this.idSprUsuario,
          delLog: 'S',
          ip: this.ipAddress,
        })
        .subscribe(
          (resp) => {
            this.initApp();
            this.modal.closeId('delete-hito');
            this.alertService.deleteOk();
          },
          (err) => {
            this.alertService.deleteError();
          }
        );
    }
  }

  calculo(dataHitos: any, pesoRestante: number) {
    let ponderacionTotalActividad = this.pesoMaximo;
    let ponderacionRestante = this.pesoMaximo;
    let pesoAterior: any = 0;
    let pesoActual: any;
    for (let i = 0; i < dataHitos.length; i++) {
      pesoActual = dataHitos[i].peso;
      pesoAterior = pesoActual + pesoAterior;
      ponderacionRestante = ponderacionTotalActividad - pesoAterior;
    }
    this.pesoRestante = ponderacionRestante;
    this.pesoTotalEditado = this.pesoRestante + this.pesoEdit;
  }

  // Modal Crear/editar
  openModal() {
    this.desahabilitarForm = false;
    this.onResetForm();
    this.setForm();
    this.modal.open(this.nameModal);
  }

  //#######################
  //RESETEA EL FORMULARIO//
  //#######################
  onResetForm() {
    this.formSubmitted = false;
    this.formHito.reset();
  }

  reset() {
    this.myInputVariable.nativeElement.value = '';
    this.archivos = [];
  }

  closeModalHito() {
    this.desahabilitarForm = false;
    this.modal.closeId('Cumplimiento de hitos');
    this.setDataTable();
    this.setForm();
    this.editPorcentajeTotal = true;
    this.editPorcentaje = false;
  }

  openModalHitoCumple() {
    this.modal.open(this.nameModalDetalleHito);
    this.setForm();
  }

  closeModalCumpleHito() {
    this.reset();
    this.modal.closeId(this.nameModalDetalleHito);
  }

}
